import React from 'react'

import Icon from '../Icon/IconView'

import styles from './LoginButton.module.css'

interface ButtonProps {
  icon?: string
  label?: string
}

const LoginButton: React.FC<ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ label, icon, ...props }) => {
  return (
    <button className={styles.loginButton} type='button' {...props}>
      {icon && <Icon className={styles.icon} icon={icon} />}
      {label}
    </button>
  )
}

export default LoginButton
